import type { FunctionComponent } from 'react';
import { useMemo } from 'react';
import { useTools } from '../../api';
import { AdminContentScreen, ToolEditor } from '../../components/admin';
import { useNumberSearchParams } from '../../hooks/useNumberSearchParams';
import { AVAILABLE_LANGUAGES } from '../../i18n/i18nextInit';
import type { ITool } from '../../interfaces/tool';

const emptyTool: ITool = {
    id: -1,
    name: AVAILABLE_LANGUAGES.reduce((acc, lang) => ({ ...acc, [lang]: '' }), {}),
    link: '',
    excludedDomiciles: [],
    includedDomiciles: [],
    global: false,
};

export const AdminTools: FunctionComponent = () => {
    const { data: tools } = useTools();

    const [toolId, setSearchParams] = useNumberSearchParams('tool');
    const displayedItem = useMemo(() => (toolId != null ? tools?.find((t) => t.id === toolId) || emptyTool : undefined), [toolId, tools]);

    const goToTool = (toolId: number) => setSearchParams({ tool: toolId.toString() });

    return (
        <AdminContentScreen
            items={tools}
            displayedItem={displayedItem}
            onCreateClick={() => goToTool(-1)}
            onItemClick={goToTool}
            itemEditorComponent={displayedItem ? <ToolEditor key={toolId} tool={displayedItem} /> : null}
        />
    );
};
